<template>
  <div class="kr-layout-content">
    <!--个人基本资料-->
    <div class="publish graphic-data">
      <div class="publish-top">
        <ul class="per-list">
          <li>视频数据</li>
        </ul>
      </div>
      <ul class="static">
        <li>
          <p>总阅读</p>
          <p>8951</p>
        </li>
        <li>
          <p>昨日阅读</p>
          <p>-</p>
        </li>
        <li>
          <p>昨日推荐</p>
          <p>-</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
    
    };
  },
  mounted() {
    
  },
  methods: {

  }
};
</script>

<style scoped>
.publish .publish-top {border: none;}
.publish .publish-top .per-list li::after {height: 0px;}
</style>